<template>
    <div class="mainBody">
        <div class="searchBox">
            <div class="searchGroup">
                <label>版本：</label>
                <el-input v-model="search_Obj.f_version" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column type="selection" align="center" width="50"></el-table-column>
                <el-table-column prop="version" label="版本号" sortable="custom"></el-table-column>
                <el-table-column prop="proportion" label="版本占比" sortable="custom">
                    <template slot-scope="scope">
                        <span>{{ scope.row.proportion }}%</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="220" align="center">
                    <template slot-scope="scope">
                        <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <Info
            width="600px"
            :id="model_id"
            title="查看车辆版本"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import listutil from "@/libs/listutil"

export default {
    name: 'carVersionList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns},
    data() {
        return {
            m_name: '车辆版本',
            menu_id: 9200,
            list_url: "/api/admin/carversion/list",
            search_Obj: {
                f_version: '',
            },
            del_Obj:{
                url:'/api/admin/carversion/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
            sortData: {
                prop: 'proportion',
                order: 'descending'
            },
        };
    },
    methods: {}
};
</script>